import React from "react";
import {HowToBuyWinePage} from "./HowToBuyWinePage";
import {AppWrapper} from "../../commons/components/wrappers/AppWrapper";

export const HowToBuyApp = () => {

    return (
        <AppWrapper.Default title={"Sprzedaż"} fullWideImage={"shop-winnica-bugara.jpg"}>
            <HowToBuyWinePage/>
        </AppWrapper.Default>
    )
};